import styled from 'styled-components'

const Page = styled.div`
  z-index: 9999;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -50px;
  text-align: center;
`

const Title = styled.h1`
  text-align: center;
`

const BrowserList = styled.div`
  display: flex;
  flex-direction: row;
  width: 300px;
  justify-content: space-between;
  margin-top: 30px;
`

const UnsupportedBrowser = () => {
  return (
    <Page>
      <Title>Please update your browser</Title>
      <div>
        <span>
          We no longer support your browser. please update your browser or use one of the
          browsers below
        </span>
      </div>
      <BrowserList>
        <a
          href="https://www.google.co.uk/chrome"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img height="40" src="/assets/img/chrome.png" />
        </a>
        <a
          href="https://www.microsoft.com/en-us/edge"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img height="40" src="/assets/img/edge.png" />
        </a>
        <a
          href="https://www.mozilla.org/en-GB/firefox/new"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img height="40" src="/assets/img/firefox.png" />
        </a>
      </BrowserList>
    </Page>
  )
}

export default UnsupportedBrowser
